import React from "react";
import PropTypes from "prop-types";
import ValuePicker from "./ValuePicker";

const DIM_LABEL = {
  label: "Label",
  sku_category: "SKU category",
  service: "Service",
};

const RefinementCard = ({ refinement, onChange, onRemove, sourceTypeId }) => {
  const { dim, key = "", values = [] } = refinement;
  const setKey = (k) => onChange({ ...refinement, key: k });
  const toggleValue = (v) => {
    const nextValues = values.includes(v) ? values.filter((x) => x !== v) : [...values, v];
    onChange({ ...refinement, values: nextValues });
  };
  return (
    <div className="rounded-card border border-card-bd bg-card p-3 mb-2">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-medium uppercase tracking-wide text-text-2">
          {DIM_LABEL[dim] || dim}
        </span>
        <button
          type="button"
          aria-label="remove refinement"
          onClick={onRemove}
          className="text-text-3 hover:text-text text-sm"
        >×</button>
      </div>
      {dim === "label" && (
        <div className="mb-2">
          <label className="block text-xs text-text-2 mb-1" htmlFor={`refinement-key-${dim}`}>Label key</label>
          <input
            id={`refinement-key-${dim}`}
            aria-label="label key"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            placeholder="e.g. env"
            className="w-full border border-border rounded-ctrl px-2 py-1 text-sm"
          />
        </div>
      )}
      <ValuePicker
        facet={dim === "label" ? "label" : dim}
        labelKey={dim === "label" ? key : ""}
        selected={values}
        onToggle={toggleValue}
        initialSearch=""
        sourceTypeId={sourceTypeId}
      />
    </div>
  );
};

RefinementCard.propTypes = {
  refinement: PropTypes.shape({
    dim: PropTypes.string.isRequired,
    key: PropTypes.string,
    values: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  sourceTypeId: PropTypes.string,
};

export default RefinementCard;
